import { CalendarPlottedEvent } from '../../services/enterpriseCalendarsApi';
import { CalendarEventChip } from './CalendarEventChip';
import { plottedEventOccursOnDay } from './calendarRecurrenceUtils';
import { getWeekDays, isSameDay, WEEKDAY_LABELS } from './calendarUtils';

type CalendarWeekViewProps = {
  anchorDate: Date;
  events: CalendarPlottedEvent[];
  onDayClick?: (day: Date) => void;
  onEventClick?: (event: CalendarPlottedEvent) => void;
};

export function CalendarWeekView({ anchorDate, events, onDayClick, onEventClick }: CalendarWeekViewProps) {
  const today = new Date();
  const days = getWeekDays(anchorDate);

  return (
    <div className="flex h-full min-h-0 flex-col overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm">
      <div className="grid grid-cols-7 border-b border-slate-200 bg-slate-50 text-center">
        {days.map((day) => {
          const isToday = isSameDay(day, today);
          return (
            <div key={day.toISOString()} className="border-r border-slate-200 px-2 py-3 last:border-r-0">
              <p className="text-xs font-semibold uppercase text-slate-500">{WEEKDAY_LABELS[day.getDay()]}</p>
              <span
                className={`mt-1 inline-flex h-8 w-8 items-center justify-center rounded-full text-sm ${
                  isToday ? 'bg-primary-600 font-semibold text-white' : 'text-slate-800'
                }`}
              >
                {day.getDate()}
              </span>
            </div>
          );
        })}
      </div>

      <div className="grid min-h-0 flex-1 grid-cols-7 overflow-y-auto">
        {days.map((day) => {
          const dayEvents = events.filter((event) => plottedEventOccursOnDay(event, day));

          return (
            <button
              key={day.toISOString()}
              type="button"
              className="min-h-[320px] border-r border-slate-100 p-2 text-left align-top last:border-r-0 hover:bg-slate-50"
              onClick={() => onDayClick?.(day)}
            >
              <div className="space-y-1">
                {dayEvents.map((event) => (
                  <CalendarEventChip
                    key={`${event.calendarId}-${event.id}-${day.toISOString()}`}
                    event={event}
                    onClick={onEventClick}
                    compact
                  />
                ))}
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
}
